module.exports = __webpack_public_path__ + "img/attachment-blue-24-dp.fd0ce85e.svg";